export default function (Alpine) {
    Alpine.store('questionForm', {
        open: false,

        show() {
            this.open = true;
        },

        close() {
            this.open = false;
        },
    });
}
